import { Input as InputComponent, Password as PasswordComponent } from '@components-deprecated'

import { rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Input = styled(InputComponent)`
  margin-bottom: ${Spacing.S16};
`

export const Password = styled(PasswordComponent)`
  margin-bottom: ${Spacing.S16};
`

export const PasswordChecksWrapper = styled.div`
  margin-top: -${Spacing.S8};
`

export const ButtonWrapper = styled.div`
  margin-top: ${Spacing.S16};
  margin-bottom: ${Spacing.S40};

  ${rwd.equalOrLessThan('phone')} {
    margin-bottom: ${Spacing.S32};
  }
`

export const AgreementsWrapper = styled.div`
  margin-top: ${Spacing.S16};
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  margin-top: ${Spacing.S16};
`

export const AcceptTermsLabelWrapper = styled.div``
